import { PhotoIcon } from '@heroicons/react/24/solid';
import React from 'react';
import Input from './Input';

const FileInput = ({ name, onChange, accept }) => {
  return <Input
    id="file-upload"
    role="button"
    onChange={(e) => onChange(e.target.files)}
    name={name}
    prefix="Choose file"
    type="file"
    accept={accept} />
}

export default FileInput;
